/* eslint-disable class-methods-use-this */
import $ from 'jquery';

/**
 * @desc Manages CityNow Curator.io feed.
 */
// TODO: Move magic css classes to a config object
export default class CityNow {
  constructor() {
    this.isInitialized = true;

    // TODO: Move selector to a constructor's argument
    if (!$('.citynow #curator-feed').length) {
      this.isInitialized = false;

      return;
    }

    this.initAsync();
  }

  initAsync() {
    const interval = setInterval(() => {
      this.$crtNetworks = $('.crt-networks');
      this.$crtFilters = this.$crtNetworks.find('[data-network]');

      if (this.$crtFilters.length) {
        clearInterval(interval);

        this.showCityNowFilters();
        this.init();
      }
    }, 500);
  }

  showCityNowFilters() {
    /* eslint-disable max-len */
    const filters = this.$crtFilters
      .toArray()
      .map((filterEl, i) => `
        <li class="js-citynow-filter citynow-filters__list-item ${i > 1 ? 'citynow-filters__list-item--hideable' : ''}" data-network="${filterEl.dataset.network}">
          ${filterEl.text}
        </li>
      `);
    /* eslint-enable max-len */

    $('.js-citynow-show-all').after(...filters);

    $('.citynow-filters').addClass('citynow-filters--visible');
  }

  init() {
    this.currentNetwork = null;
    this.$allFilters = $('.js-citynow-filter');

    this.$allFilters
      .click((filterEl) => {
        const $this = $(filterEl.target);

        if ($this.attr('class').includes('--active')) {
          return;
        }

        try {
          if (!$this.hasClass('js-citynow-show-all')) {
            this.currentNetwork = $this.data('network');
          }

          this.$crtNetworks.find(`[data-network="${this.currentNetwork}"]`).get(0).click();

          this.$allFilters.removeClass('citynow-filters__list-item--active');

          $this.addClass('citynow-filters__list-item--active');
        } catch (error) {
          console.error('CityNow: Unknown filter.', error);
        }
      });

    // TODO: Move code below to a separate method (for instance 'attachEventListeners')

    $('.js-show-more-posts').click(() => {
      $('.crt-load-more').click();
    });

    $('.js-filters-toggle').click(() => {
      $('.js-citynow-filters').toggleClass('citynow-filters--compact');
    });
  }
}
